import { css, SerializedStyles, keyframes } from '@emotion/core';
import theme from '../../styles/theme';

const { colors, fonts } = theme;

const fadeIn: SerializedStyles = keyframes`
  0%   {
    visibility: hidden;
  }
  80%   {
    visibility: hidden;
    opacity: 0;
  }
  100%   {
    visibility: visible;
    opacity: 1;
  }
`;

const popupStyles = css`
  position: fixed;
  right: 2rem;
  top: 6rem;
  width: 12rem;
  text-align: left;
  background-color: ${colors.white};
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  white-space: normal;
  z-index: 4;
  animation: ${fadeIn} 5s;
`;

const popupHeadTextStyles = css`
  margin: 0;
  font-size: 1.125rem;
`;

const closeButtonStyles = css`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.labelGray};
  cursor: pointer;
  &:hover {
    color: ${colors.gradientGray};
  }
`;

const popupBodyStyles = css`
  font-size: 0.875rem;
`;

const popupLinkStyles = css`
  background-color: ${colors.lightBlue};
  color: ${colors.white};
  font-size: 1rem;
  font-family: ${fonts.fontSemi};
  width: 100%;
  text-align: center;
  padding: 0.5rem 0;
`;

export default {
  popupStyles,
  popupHeadTextStyles,
  popupBodyStyles,
  closeButtonStyles,
  popupLinkStyles,
};
